<template>
  <b-form @submit.prevent="onSubmit()" class="w-100">
      <b-row>
        <b-col md="7">
          <b-row>
            <b-col md="6">
              <label class="chr-label" v-translate>Booking between</label>
              <DatePicker v-model="bookingFrom" key="bookingFrom" lang="en" size="sm" />
            </b-col>
            <b-col md="6">
              <label class="chr-label" v-translate>and</label>
              <DatePicker v-model="bookingTo" key="bookingTo" size="sm" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <label class="chr-label" v-translate>Departure between</label>
              <DatePicker v-model="travelFrom" key="travelFrom" lang="en" size="sm" />
            </b-col>
            <b-col md="6">
              <label class="chr-label" v-translate>and</label>
              <DatePicker v-model="travelTo" key="travelTo" lang="en" size="sm" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="$gettext('Booking number')"
                label-class="chr-label"
                label-for="booking-number"
                class="mb-0"
                >
                <b-input
                  type="text"
                  name="rezervare"
                  id="booking-number"
                  v-model="params.bookingId"
                  size="sm" />
                </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$gettext('Passenger name')"
                label-class="chr-label"
                label-for="name"
                class="mb-0"
                >
                <b-input
                  type="text"
                  name="pasager"
                  v-model="params.name"
                  id="name"
                  size="sm" />
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="$gettext('Key word')"
                label-class="chr-label"
                label-for="key-word"
                >
                <b-input
                  type="text"
                  name="keyWord"
                  v-model="params.keyword"
                  id="key-word"
                  size="sm" />
                </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="5" class="pt-4">
          <BookingSummary :results="results"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12"><hr class="my-1"></b-col>
        <b-col sm="12" class="d-flex align-items-center justify-content-end">
          <b-button variant="warning" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2" v-translate>Search</span></b-button>
        </b-col>
      </b-row>
  </b-form>
</template>

<script>

import BookingSummary from './booking_summary'
import moment from 'moment'

import DatePicker from 'b2b-common/components/datepicker'

export default {
  props: ['params', 'results'],
  components: { DatePicker, BookingSummary },
  computed: {
    bookingFrom: {
      get () {
        return this.params.bookingFrom ? moment(this.params.bookingFrom, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.bookingFrom = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    bookingTo: {
      get () {
        return this.params.bookingTo ? moment(this.params.bookingTo, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.bookingTo = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    travelFrom: {
      get () {
        return this.params.travelFrom ? moment(this.params.travelFrom, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.travelFrom = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    travelTo: {
      get () {
        return this.params.travelTo ? moment(this.params.travelTo, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.travelTo = val ? moment(val).format('DD-MM-YYYY') : null
      }
    }
  },
  methods: {
    onSubmit () {
      this.$emit('search', this.params)
    }
  }
}
</script>
